import { z } from 'zod';

export const getSizeCatalogsSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
  })
);

export type GetSizeCatalogs = z.infer<typeof getSizeCatalogsSchema>;
